<template lang="pug">
  #gvl-header.white.px-5
    #header-logos: v-row.align-center.my-0.px-0.px-sm-2.py-5
      v-col(cols="4" md="5" lg="6")
        a.text-decoration-none(href="https://gvl.de/" target="blank")
          img.logo--new-start.mr-2.mr-sm-3.mr-md-6(src="@/assets/images/logo_detail.png")

        a.text-decoration-none(href="https://www.bundesregierung.de/breg-de/bundesregierung/staatsministerin-fuer-kultur-und-medien/corona-hilfen" target="blank")
          img.logo--new-start(src="@/assets/images/logo_new_start.png")

      v-col.nav-menu(v-if="!isSignMode" cols="8" md="7" lg="6")
        a(
          v-for="menu in menuItems"
          :key="menu.route"
          :class="$route.name === menu.route && 'menu-selected'"
          @click="gotoRoute(menu.route)"
        ) {{ menu.label }}

</template>

<script>
import { Vue, Component } from 'vue-property-decorator'
import FormMixin from '@/mixins/form'

@Component({
  mixins: [
    FormMixin
  ]
})
export default class PageHeader extends Vue {
  get menuItems () {
    return [
      {
        label: 'Übersicht',
        route: 'home',
        hidden: false
      },
      {
        label: 'FAQ',
        route: 'faq',
        hidden: false
      },
      {
        label: 'Fördergrundsätze',
        route: 'funding',
        hidden: false
      },
      {
        label: 'Kontakt',
        route: 'contact',
        hidden: false
      }
    ]
  }
}
</script>

<style lang="sass">
#gvl-header
  padding-top: 146px

  #header-logos
    position: fixed
    top: 0
    left: 0
    right: 0
    background-color: #fff
    z-index: 99

    .row
      max-width: 1200px
      margin: auto

  .logo--new-start
    height: 75px

  .top-line
    border-top: 4px solid #ccc

  .nav-menu
    display: flex
    align-items: center
    justify-content: space-between

    a
      color: #000
      font-size: 24px
      user-select: none

      &.menu-selected
        color: #6E6E6E
        pointer-events: none

  @media screen and (max-width: 960px)
    padding-top: 100px

    .logo--new-start
      height: 50px

    .nav-menu a
      font-size: 18px

  @media screen and (max-width: 576px)
    padding-top: 80px

    .logo--new-start
      height: 40px

    .nav-menu a
      font-size: 14px

  @media screen and (max-width: 460px)
    padding-top: 70px

    .logo--new-start
      height: 30px

    .nav-menu a
      font-size: 12px
</style>
